import { BaseApi } from '@/core/api/base.api'
import _ from 'lodash'
import {Room} from "@/core/api/room.api";
import {RoomUser} from "@/core/api/room.user.api";
import {roomUserBehaviorService} from "@/core/service/room.user.behavior.service";

class RoomUserBehaviorApi extends BaseApi {
  #data = {
    speak: {
      data: {
        users: {},
        totalTimeSeconds: 0
      },
      lastLogIdx: 0,
      lastReqTime: 0
    }
  }

  constructor() {
    super()

    RoomUser.Behavior = this;

    Room.ready(async e => {
      this._eventListen(this.#Events)
    })
  }

  #Events = {

  }

  async getSpeakDataMap() {
    let speakData = this.#data.speak.data;

    if(RoomUser.getRoomUserList().filter(ru => {
      return RoomUser.isParticipantRole(ru);
    }).length === 0){
      return _.cloneDeep(speakData);
    }

    if(Date.now() - this.#data.speak.lastReqTime < 10*1000){
      console.warn('call time limit :',
          (Date.now() - this.#data.speak.lastReqTime) / 1000
      );
      return _.cloneDeep(speakData);
    }

    let {data} = await roomUserBehaviorService.getSpeakDataList({
      afterLogIdx: this.#data.speak.lastLogIdx
    });

    this.#data.speak.lastLogIdx = data.lastLogIdx;
    this.#data.speak.lastReqTime = Date.now();

    if(!data.list){
      console.warn('result list is null :', data);
      return _.cloneDeep(speakData);
    }

    if(Object.keys(speakData.users).length === 0){
      data.list.reduce((result, d) => {
        result.users[d.userId] = {speakTimeSeconds: d.speakTimeSeconds};
        result.totalTimeSeconds += d.speakTimeSeconds;
        return result;
      }, speakData);
    }else{
      // {userId, speakTimeSeconds}
      data.list.forEach(data => {
        let userData = speakData.users[data.userId];
        if(userData){
          userData.speakTimeSeconds += data.speakTimeSeconds;
        }else{
          speakData.users[data.userId] = {speakTimeSeconds: data.speakTimeSeconds};
        }
      });

      speakData.totalTimeSeconds = 0;
      for(let userId in speakData.users){
        speakData.totalTimeSeconds += speakData.users[userId].speakTimeSeconds;
      }
    }

    return _.cloneDeep(speakData);
  }

  async parseUserSpeakData({roomUser, volume}) {
    if(!Room.User.isMe(roomUser)){
      return;
    }else if(!Room.User.isParticipantRole(roomUser)){
      return;
    }

    const now = Room.getCurrentDateTime();

    // 최소 볼륨
    const minVolume = 3;
    // 전송 기준 시간
    const limitSpeakTime = 30*1000;
    // speak data
    let obj = roomUser._speakTimeObj;

    if(!obj){
      if(volume >= minVolume){
        console.log('## [speak data] - 데이터 생성 :', volume)
        roomUser._speakTimeObj = {
          beginSpeakTime: now,
          speakTime: 0,
          lastSpeakTime: now,
          prevVolume: volume
        };
      }
      return;
    }

    const checkData1 = async () => {
      if(now - obj.beginSpeakTime >= 10*1000 && obj.speakTime <= 2000){
        console.log('## [speak data] - 데이터 버림 : %d초 동안 %d초 말함', (now - obj.beginSpeakTime)/1000, obj.speakTime/1000)
        roomUser._speakTimeObj = {
          beginSpeakTime: now,
          speakTime: 0,
          lastSpeakTime: now,
          prevVolume: volume
        };
      }
      await checkData2();
    }

    const checkData2 = async () => {
      if(now - obj.beginSpeakTime < limitSpeakTime && obj.speakTime < limitSpeakTime){
        return;
      }
      if(obj.speakTime < 2000){
        return;
      }

      let sendData = {
        speakTimeSeconds: obj.speakTime / 1000,
        begin: obj.beginSpeakTime,
        end: now,
      };
      delete roomUser._speakTimeObj;

      console.log('## [speak data] - 데이터 전송 :',
          (sendData.end-sendData.begin)/1000,
          JSON.stringify(sendData, null, '  '))
      await roomUserBehaviorService.sendSpeakData(sendData);
      if(volume >= minVolume){
        roomUser._speakTimeObj = {
          beginSpeakTime: now,
          speakTime: 0,
          lastSpeakTime: now,
          prevVolume: volume
        };
      }
    }

    if(volume >= minVolume){
      if(obj.prevVolume > 0){
        obj.speakTime += now - obj.lastSpeakTime;
        obj.lastSpeakTime = now;
        obj.prevVolume = volume;

        await checkData2();
      }else{
        obj.lastSpeakTime = now;
        obj.prevVolume = volume;

        await checkData1();
      }
    }else{
      if(obj.prevVolume > 0){
        obj.speakTime += now - obj.lastSpeakTime;
        obj.lastSpeakTime = null;
        obj.prevVolume = 0;
      }

      await checkData1();
    }
  }
}

export const RoomUserBehavior = new RoomUserBehaviorApi()
